import script from "./AuditorioLayoutV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditorioLayoutV2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QVideo});
